<template>
  <div class="list" >
    <div
      v-for="(item, index) in items"
      :key="index"
      class="list-item flex flex-align-center" >
      <p class="greedy ellipsis">{{ item }}</p>
      <SBIcon
        v-if="!readOnly"
        class="ml-2"
        :icon="SBIconList.TRASH"
        :color="SBColors.blackUltralight"
        :hover-icon-color="SBColors.blackPrimary"
        :hover-size="24"
        :size="14"
        pointer
        @click="removeCallback(item)" />
    </div>
  </div>
</template>

<script>
import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';

export default {
  name: 'DefaultList',
  components: {
    SBIcon,
  },
  props: {
    items: {
      type: Array,
      required: true,
      default: () => ([]),
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: true,
    },
    removeCallback: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data() {
    return {
      SBColors,
      SBIconList,
    };
  },
};
</script>

<style scoped lang="scss">
.list-item {
  p {
    font-size: 14px;
    font-weight: normal;
    color: $blackPrimary;
  }
}
</style>
